import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_insert_invoicing_project_rule_priorityService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { rule_id: string, project_id: number, priority: number }): Promise<{ exception_id?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.rule_id)) {
      $missingRequiredInParams.push('\'rule_id\'');
    }
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.priority)) {
      $missingRequiredInParams.push('\'priority\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

